import React from 'react';
import { useTranslation } from 'react-i18next';

/** Texto traduzido em JSX, utilizável em qualquer componente (mesmo sem `t` no escopo). */
export const T: React.FC<{ k: string }> = ({ k }) => {
    const { t } = useTranslation();
    return <>{t(k)}</>;
};

export default T;
